module.exports = __webpack_public_path__ + "static/media/price-management-icon.f2f223df.svg";